import { useEffect, useState, useCallback } from 'react';
import styles from './navbar.module.scss';
import { scrollTo } from '../../utils/scroll';
export default function Navbar(props) {
  // const [y, setY] = useState(window.scrollY);
  const [rendering, setRendering] = useState(false);

  const setView = (viewIndex) => {
    let elements = document.querySelectorAll(`.${styles['nav-item']}`);
    let active = document.querySelector(`.${styles['active']}`);
    // console.log('rendering', rendering);
    // smoothScroll(625);
    const removeStyle = [
      `${styles['active']}`,
      `${styles['outLeft']}`,
      `${styles['inRight']}`,
      `${styles['outRight']}`,
      `${styles['inLeft']}`,
    ];
    elements.forEach((element) => {
      removeStyle.forEach((val) => {
        if (element.classList.contains(val)) {
          element.classList.remove(val);
        }
      });
    });

    if (props.viewDirection === 'up')
      active.classList.add(`${styles['outRight']}`);
    else active.classList.add(`${styles['outLeft']}`);

    if (props.viewDirection === 'up')
      elements[2 - viewIndex].classList.add(
        `${styles['active']}`,
        `${styles['inLeft']}`
      );
    else
      elements[2 - viewIndex].classList.add(
        `${styles['active']}`,
        `${styles['inRight']}`
      );
  };

  useEffect(() => {
    setView(props.origin.index);
  }, []);

  useEffect(() => {
    setView(props.destination.index);
  }, [props.destination]);

  return (
    <div className={styles['navbar']}>
      <div
        className={styles['nav-item']}
        data-key="2"
        onClick={() => {
          // clickChangeView(2);
          props.fullpageApi.moveTo(3, 0);
        }}
      >
        mobile app
      </div>
      <div
        className={styles['nav-item']}
        data-key="1"
        onClick={() => {
          // clickChangeView(1);
          props.fullpageApi.moveTo(2, 0);
        }}
      >
        website &#38; desktop app
      </div>
      <div
        className={`${styles['nav-item']} ${styles['active']}`}
        data-key="0"
        onClick={() => {
          props.fullpageApi.moveTo(1, 0);
        }}
      >
        home
      </div>
    </div>
  );
}
